/* ==========================================================================
   Hero slideshow — Polton All Stars

   Only one slide is ever visible, aria-visible or focusable. This is the whole
   point: Zizu's hero renders every headline stacked on top of the others and
   is illegible. Inactive slides here get aria-hidden and their links get
   tabindex="-1", so keyboard and screen-reader users never land in a slide
   they cannot see.

   Autoplay pauses on hover, on focus-within, when the tab is hidden, and is
   never started at all for prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.slideshowReady === '1') return;
    root.dataset.slideshowReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length <= 1) return;

    var dots  = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var prev  = root.querySelector('[data-slide-prev]');
    var next  = root.querySelector('[data-slide-next]');

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantsAuto = root.dataset.autoplay === 'true' && !reduced;
    var interval = parseInt(root.dataset.interval, 10) || 6000;

    var index = 0;
    var timer = null;
    var paused = false;

    function setFocusable(slide, on) {
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (on) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    function show(n, announce) {
      index = (n + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        setFocusable(slide, active);
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (announce) {
        // move focus to the newly shown slide so keyboard users keep their place
        var target = slides[index];
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      stop();
      if (!wantsAuto || paused || document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { show(index - 1, true); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1, true); restart(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.slideDot, 10), true);
        restart();
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { show(index - 1, true); restart(); }
      if (e.key === 'ArrowRight') { show(index + 1, true); restart(); }
    });

    root.addEventListener('mouseenter', function () { paused = true;  stop();  });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin',    function () { paused = true;  stop();  });
    root.addEventListener('focusout',   function (e) {
      if (!root.contains(e.relatedTarget)) { paused = false; start(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // basic swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { show(dx < 0 ? index + 1 : index - 1); restart(); }
      x0 = null;
    }, { passive: true });

    show(0);
    start();
  }

  function boot() { document.querySelectorAll('[data-slideshow]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slideshow]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-slideshow]').forEach(function (r) {
      r.dataset.slideshowReady = '';
    });
  });
})();
